import Bugsnag from '@bugsnag/js'
import { Add } from '@mui/icons-material'
import { Box, Icon, IconButton, Typography } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import AdxInput from 'components/custom/AdxInput'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import { ErrorMessage, Field, FieldArray, Form, Formik } from 'formik'
import React, { useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import {
  deleteOvertimeRate,
  postOvertimeRate,
} from 'services/api/modules/payroll/payroll-config/overtimeConfigApi'
import * as yup from 'yup'

const OvertimeRateModal = ({ children, props }) => {
  const [isModalOpen, setModalOpen] = useState(false)
  const handleOpen = () => {
    setModalOpen(true)
  }
  const handleClose = () => {
    setModalOpen(false)
  }
  const queryClient = useQueryClient()
  const { mutate: addOvertimeRate } = useMutation(postOvertimeRate, {
    onSuccess: () => {
      queryClient.invalidateQueries('getOvertimeRate')
    },
    onError: (error) => {
      if (error.status === 422) {
        console.log(error)
      } else {
        Bugsnag.notify(error.data)
      }
    },
  })

  // const { mutate: removeOvertimeRate } = useMutation(deleteOvertimeRate, {
  //   // onSuccess: () => {
  //   //   queryClient.invalidateQueries("getOvertimeRate");
  //   // },
  // });

  const handleSave = async (values) => {
    let arr = values.custom_overtime.map((item) => {
      const { status, ...rest } = item
      let obj = { ...rest }
      return obj
    })
    let data = { custom_overtime: arr }
    // await alert(JSON.stringify(data, null, 2));
    addOvertimeRate(data)
    setModalOpen(false)
  }
  const validationSchema = yup.object().shape({
    custom_overtime: yup.array().of(
      yup.object().shape({
        title: yup
          .string()
          .required('This field is required')
          .matches(/^[a-zA-Z0-9\s]*$/, 'This field must contain only alphanumeric'),
        rate: yup
          .number('This field only accept a number')
          .min(0.01, 'The rate cannot be less than 0.01')
          .max(99.9, 'The rate cannot exceed 99.9')
          .transform((value) => (isNaN(value) ? undefined : value))
          .required('This field is required'),
      })
    ),
  })
  return (
    <>
      <Box onClick={handleOpen}>{children}</Box>

      <Formik
        initialValues={{
          custom_overtime: props
            ? props.map((list) => ({
                id: list.id,
                title: list.title,
                rate: list.rate,
                status: list.default,
              }))
            : [],
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => handleSave(values)}
      >
        {({ values, handleChange, setFieldValue, handleBlur, touched, errors, handleSubmit }) => {
          return (
            <Form>
              <AdxFormModal
                open={isModalOpen}
                onClose={handleClose}
                handleClose={handleClose}
                title="Overtime Policy"
                childPadding={false}
                enableFooter
                actionText="Save"
                handleAction={handleSubmit}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  flexDirection="column"
                  justifyContent="space-between"
                  sx={{ width: 700 }}
                >
                  <FieldArray name="custom_overtime">
                    {({ push, remove, form }) => {
                      const { values } = form
                      const { custom_overtime } = values
                      const handleRemoveOvertime = (index) => {
                        remove(index)
                      }
                      return (
                        <Box sx={{ px: 3, py: 2, width: 1 }}>
                          <Box
                            sx={{
                              border: 1,
                              borderColor: 'gray-line.main',
                              borderRadius: '4.5px',
                            }}
                          >
                            <Box
                              sx={{
                                p: 2,
                              }}
                            >
                              {custom_overtime.map((items, index) => {
                                return (
                                  <Box
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="flex-start"
                                    sx={{ px: 1, py: 1, gap: 1 }}
                                  >
                                    <Box sx={{ width: 1 }}>
                                      <Field
                                        name={`custom_overtime.${index}.title`}
                                        as={AdxInput}
                                        disabled={items.status === 0}
                                        value={
                                          items.status === 0
                                            ? `${items.title} (Default)`
                                            : `${items.title}`
                                        }
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        errorMessage={
                                          <ErrorMessage
                                            name={`custom_overtime.${index}.title`}
                                            component={AdxErrorMessage}
                                          />
                                        }
                                        isErrorShown={
                                          touched?.custom_overtime &&
                                          errors?.custom_overtime &&
                                          touched?.custom_overtime[index]?.title &&
                                          errors?.custom_overtime[index]?.title
                                        }
                                      />
                                    </Box>
                                    <Box
                                      sx={{ width: 1 }}
                                      display="flex"
                                      alignItems="flex-start"
                                      justifyContent="space-between"
                                    >
                                      <Box display="flex" alignItems="flex-start" columnGap={1}>
                                        <Box sx={{ width: '100px' }}>
                                          <Field
                                            name={`custom_overtime.${index}.rate`}
                                            as={AdxInput}
                                            type="number"
                                            onChange={(e) => {
                                              setFieldValue(
                                                `custom_overtime.${index}.rate`,
                                                parseFloat(e.target.value)
                                              )
                                            }}
                                            onBlur={handleBlur}
                                            errorMessage={
                                              <ErrorMessage
                                                name={`custom_overtime.${index}.rate`}
                                                component={AdxErrorMessage}
                                              />
                                            }
                                            isErrorShown={
                                              touched?.custom_overtime &&
                                              errors?.custom_overtime &&
                                              touched?.custom_overtime[index]?.rate &&
                                              errors?.custom_overtime[index]?.rate
                                            }
                                          />
                                        </Box>
                                        <Box display="flex" alignItems="center" height="45px">
                                          <Typography color="light-gray-text.main">
                                            times of hourly salary
                                          </Typography>
                                        </Box>
                                      </Box>
                                    </Box>
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      height="45px"
                                      width="90px"
                                    >
                                      {items.status !== 0 && (
                                        <IconButton
                                          variant={'ghost-destructive'}
                                          sx={{
                                            display: items.status === 0 ? 'none' : 'flex',
                                            color: 'error.main',
                                            cursor: 'pointer',
                                          }}
                                          onClick={() => handleRemoveOvertime(index)}
                                        >
                                          <Icon>remove_circle</Icon>
                                        </IconButton>
                                      )}
                                    </Box>
                                  </Box>
                                )
                              })}
                            </Box>
                            <Box sx={{ borderTop: 1, borderColor: 'gray-line.main' }}>
                              <AdxButton
                                variant={'ghost'}
                                sx={{
                                  width: '100%',
                                  display: 'flex',
                                  justifyContent: 'center',
                                }}
                                onClick={() => push({ title: '', rate: '', status: 1 })}
                                startIcon={<Add />}
                              >
                                Add policy
                              </AdxButton>
                            </Box>
                          </Box>
                        </Box>
                      )
                    }}
                  </FieldArray>
                </Box>
              </AdxFormModal>
            </Form>
          )
        }}
      </Formik>
    </>
  )
}

export default OvertimeRateModal
